import { render, staticRenderFns } from "./ListReviews.vue?vue&type=template&id=3f235cc2&"
import script from "./ListReviews.vue?vue&type=script&lang=js&"
export * from "./ListReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports